class CounterOrderSection {
    public CounterIndex: number;

    public setEmptyCommonValueFields(value: string): void {
        for (let key of Object.keys(this)) {
            if (typeof (this[key]) === "object" && !this[key].Value)
                this[key].Value = value;
        }
    }
}

export { CounterOrderSection };
